<template>
  <div>
    <el-upload
      class="upload-demo"
      :action="`${uploadUrl}`"
      name="foto"
      :multiple="isMultiple"
      :headers="{ 'Accept': 'application/json'}"
        :on-success="handleSuccess"
        :on-change="handleChange"
        :file-list="fileList"
        :on-remove="handleRemove"
        :on-error="handleError"
      list-type="picture">
      <div class="text-center my-3">
        <h4>Seleccionar foto</h4>
        <el-button type="success" style="width:100%" plain>Seleccionar imágen</el-button>
        <div slot="tip" class="el-upload__tip">Solo fotos jpg/png de 2-3 Mb.</div>
      </div>
    </el-upload>
  </div>
</template>

<script>
module.exports = {
  props: ['fotos', 'recordId', 'baseUrl', 'isMultiple'],
  data() {
    return {
      fileList: [],
      uploadUrl: null
    };
  },
  created() {
    //do something after creating vue instance
    this.uploadUrl = this.baseUrl + '&_token=' + Larapp.csrfToken;
    this.fileList = this.photos;
  },
  methods: {
    handleSuccess(response, file, fileList) {
      if (response.errors) {
        console.log(file.name + ' could not be uploaded.', 'error');
      } else {
        if (response.name) {
          console.log('File ' + response.name + ' uploaded successfully');
        }
      }
    },
    handleRemove() {},
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    handleError(err, file, fileList) {
      if (err) {
        console.log(file.name + ' could not be uploaded.', 'error');
      }
    }
  }
};
</script>

<style>
.el-upload {
  width: 100% !important;
}
</style>
